module.exports = __webpack_public_path__ + "img/Kielland_En_stor_novellist.fab94bdb.jpg";